module.exports = __webpack_public_path__ + "static/media/user-white.8feff939.png";